import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { connect } from 'react-redux';
import './customerInvoice.css';
import { PriceFormat } from "../../utils";
import '../../../css/error.css';
import { toast } from 'react-toastify';


function ForbiddenOrderItems({ orderItems }) {
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        if (orderItems.length === 0) {
            const timeout = setTimeout(() => {
                setShowError(true);
            }, 3000); // Change the delay as needed
            return () => clearTimeout(timeout);
        }
    }, [orderItems]);

    return (
        <div>
            {showError ? (
                <div className="card" style={{ height: '100vh', width: '100%' }}>
                    <div
                        className="card-body"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <svg id="error" width="472" height="150" viewBox="0 0 472 223" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M157.25 145.234V142.234H154.25H128.844V9.25V6.25H125.844H98.1406H96.5073L95.6209 7.6218L3.93341 149.512L3.45312 150.256V151.141V166.469V169.469H6.45312H96.6875V214V217H99.6875H125.844H128.844V214V169.469H154.25H157.25V166.469V145.234ZM96.6875 142.234H41.4637L96.6875 55.8751V142.234ZM190.771 196.913L190.777 196.921C201.97 212.311 219.156 219.812 241.719 219.812C264.575 219.812 281.875 212.112 292.97 196.318C303.9 180.76 309.125 157.379 309.125 126.672V92.9219V92.9075L309.125 92.8932C308.841 63.2147 303.468 40.7038 292.507 25.8897C281.393 10.774 264.151 3.4375 241.438 3.4375C218.507 3.4375 201.16 11.0297 190.056 26.6357C179.117 42.0093 173.891 65.1166 173.891 95.4531V130.188V130.207L173.891 130.227C174.269 159.282 179.751 181.661 190.771 196.913ZM268.268 44.5644L268.275 44.575C274.012 53.8757 277.109 69.209 277.109 91.0938V133.684C276.828 154.883 273.558 169.848 267.73 179.069L267.724 179.078L267.719 179.086C262.14 188.046 253.647 192.578 241.719 192.578C229.663 192.578 220.917 187.813 215.031 178.267C209.086 168.379 205.906 152.691 205.906 130.75V89.1385C206.093 68.5118 209.222 53.7511 214.892 44.4169C220.36 35.4156 229.006 30.8125 241.438 30.8125C253.96 30.8125 262.705 35.4607 268.268 44.5644ZM377.281 95.9688H374.281V98.9688V120.203V123.203H377.281H396.807C410.162 123.388 419.911 126.566 426.497 132.308C433.011 137.986 436.438 146.215 436.438 157.469C436.438 169.209 433.268 177.76 427.347 183.598C421.423 189.438 412.678 192.578 400.625 192.578C389.379 192.578 380.745 189.513 374.391 183.667C368.059 177.842 364.812 170.061 364.812 160V157H361.812H335.656H332.656V160C332.656 177.859 338.98 192.447 351.691 203.47L351.7 203.477C364.444 214.443 380.842 219.812 400.625 219.812C420.434 219.812 436.806 214.24 449.458 202.872C462.183 191.44 468.453 176.002 468.453 156.906C468.453 144.459 465.209 133.725 458.578 124.88C453.348 117.803 446.375 112.392 437.76 108.606C445.218 104.445 451.35 98.8956 456.109 91.9554C462.216 83.1851 465.359 73.9752 465.359 64.375C465.359 45.5465 459.656 30.4753 447.951 19.5706C436.281 8.69853 420.329 3.4375 400.484 3.4375C381.569 3.4375 365.724 9.03545 353.189 20.3856C340.736 31.6534 334.484 45.9202 334.484 62.9688V65.9688H337.484H363.5H366.5V62.9688C366.5 53.0596 369.584 45.4052 375.559 39.6822L375.56 39.6816C381.642 33.8535 389.841 30.8125 400.484 30.8125C411.972 30.8125 420.038 33.6933 425.253 38.9297C430.472 44.1682 433.344 52.272 433.344 63.8125C433.344 73.7723 430.104 81.3955 423.798 87.0283C417.455 92.6951 408.576 95.7852 396.805 95.9688H377.281Z" stroke="#73879C" strokeWidth="6" />
                        </svg>
                        <span style={{ fontSize: '5vh' }}>Access Denied...!</span>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

const CustomerInvoice = (props) => {

    const { id } = useParams();

    const [data, setData] = useState([]);
    const [orderItemsData, setOrderItemsData] = useState([]);
    const [orderData, setOrderData] = useState({});
    const [payment, setPaymentData] = useState({});

    useEffect(() => {
        if (navigator.onLine) {
            axios.get('/customerInvoice/getInvoiceDetails', { params: { id } })
                .then(result => {
                    if (result.data.length > 0) {
                        setData(result.data)
                    }
                }).catch(err => {
                    toast.error(`${err.response.data}`)
                })
        } else {
            toast.info('No Internet connection')
        }
    }, [id, navigator.onLine]);

    useEffect(() => {
        if (data.length > 0) {
            let orderItems = data.map(val => {
                setOrderItemsData(val.orderItems)
                setOrderData(val.orders)
                setPaymentData(val.paymentmethods)
            })
        }
    }, [data]);

    return (
        <div >
            {orderItemsData.length > 0 ?
                <div>
                    <nav className="navbar navbar-light bg-light">
                        <a className="navbar-brand" href="/">
                            <div>
                                <img style={{ height: '40px' }} src={require('../../../images/logo.png')} alt={'gusta logo'} />
                            </div>
                        </a>
                    </nav>
                    <div className="orderItems_card" >
                        <main className="orderItems_table">
                            <section className="orderItems_table__header " style={orderData.status === "Initiated" ? { borderTopStyle: 'solid', borderTopColor: '#007bff', borderWidth: '10px' } :
                                orderData.status === "Delivered" ? { borderTopStyle: 'solid', borderTopColor: '#28a745', borderWidth: '10px' } :
                                    (orderData.status === "DispatchedMissing" || orderData.status === "Dispatched") ? { borderTopStyle: 'solid', borderTopColor: '#ffc107', borderWidth: '10px' } :
                                        orderData.status === "Processed" ? { borderTopStyle: 'solid', borderTopColor: '#17a2b8', borderWidth: '10px' } : ''}>

                                <h1 className="table_header-h1" >Customer Invoice</h1>
                                <div >
                                    <p className={`
                                            orderStatus 
                                                ${orderData.status === 'Initiated' ? 'bg-primary'
                                            : orderData.status === 'Delivered' ? 'bg-success'
                                                : (orderData.status === 'DispatchedMissing' || orderData.status === 'Dispatched') ? 'bg-warning'
                                                    : orderData.status === 'Processed' ? 'bg-info' : 'bg-light'
                                        }
                                                table_header_status 
                                                lg 
                                                font-weight-bold 
                                                text-center 
                                                text-white 
                                                w-5 
                                                p-2 
                                                mt-3 
                                                mr-1`}>
                                        {orderData.status}
                                    </p>
                                </div>
                            </section>
                            <section className="table__orderItems__body_card shadow-2-strong" style={{ overflow: "hidden" }}>
                                <div className="row">
                                    <div className="col">
                                        <div className="text-center">
                                            <h6 className=" text-dark" style={{ fontWeight: 'bold', marginTop: '10px' }}>{orderData.name}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="text-right">
                                            <h6 className=" text-danger" style={{ fontWeight: 'bold', marginTop: '10px' }} >Payment Method</h6>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="text-left">
                                            <h6 className=" text-danger" style={{ fontWeight: 'bold', marginTop: '10px' }}>{payment.name}</h6>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section className="table__orderItems__body">
                                {orderItemsData.length > 0 ? (
                                    <table className="table__orderItems">
                                        <thead className="table__orderItems__thead">
                                            <tr className="table__orderItems__tr">
                                                <th className="table__orderItems__th"> ID </th>
                                                <th className="table__orderItems__th"> Item Name </th>
                                                <th className="table__orderItems__th"> Per Item Price </th>
                                                <th className="table__orderItems__th"> Quantity </th>
                                                <th className="table__orderItems__th"> Discount </th>
                                                <th className="table__orderItems__th"> Total Price </th>
                                            </tr>
                                        </thead>
                                        <tbody className="table__orderItems__tbody">
                                            {orderItemsData.map((item, index) => (
                                                <tr className="table__orderItems__tr" key={index + 1}>
                                                    <td className="table__orderItems__td">{index + 1}</td>
                                                    <td className="table__orderItems__td">{item.itemName}</td>
                                                    <td className="table__orderItems__td">{item.unitPrice !== undefined && item.unitPrice !== '' ? PriceFormat(item.unitPrice) : ''}</td>
                                                    <td className="table__orderItems__td">{item.quantity}</td>
                                                    <td className="table__orderItems__td">{item.discount}</td>
                                                    <td className="table__orderItems__td">{PriceFormat(item.price)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        {orderItemsData.length > 0 ? (
                                            <tbody>
                                                <tr className="table__orderItems__tr">
                                                    <td >{''}</td>
                                                    <td colSpan="3">{''}</td>
                                                    <td className="table__orderItems__td font-weight-bold">{'Sub Total'}</td>
                                                    <td className="table__orderItems__td font-weight-bold">{PriceFormat(orderData.subTotal)}</td>
                                                </tr>
                                                {orderData.totalDiscount > 0 &&
                                                    <tr className="table__orderItems__tr">
                                                        <td >{''}</td>
                                                        <td colSpan="3">{''}</td>
                                                        <td className="table__orderItems__td font-weight-bold">Order Discount({(orderData.totalDiscount) + "%"})</td>
                                                        <td className="table__orderItems__td font-weight-bold">{PriceFormat(Number(orderData.subTotal * orderData.totalDiscount / 100))}</td>
                                                    </tr>
                                                }
                                                <tr className="table__orderItems__tr">
                                                    <td >{''}</td>
                                                    <td colSpan="3">{''}</td>
                                                    <td className="table__orderItems__td font-weight-bold">{'Delivery Charge'}</td>
                                                    <td className="table__orderItems__td font-weight-bold">{PriceFormat(orderData.deliveryCharges)}</td>
                                                </tr>
                                                <tr className="table__orderItems__tr ">
                                                    <td >{''}</td>
                                                    <td colSpan="3">{''}</td>
                                                    <td className="table__orderItems__td " style={{ fontSize: '20px' }}>{'Total'} </td>
                                                    <td className="table__orderItems__td" style={{ fontSize: '20px' }}>{PriceFormat(orderData.totalPrice)}</td>
                                                </tr>
                                            </tbody>
                                        ) : null}
                                    </table>
                                ) : null}
                            </section>

                            <section className="table__orderItems__body table__orderItems__body1">
                                {orderItemsData.length > 0
                                    ? orderItemsData.map((value, index, total) => {
                                        return (
                                            <div style={{ margin: '15px', marginTop: '5px', color: 'black' }}>
                                                <table style={{ width: "90%", marginTop: "1%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className="table__orderItems__td1 " style={{ width: "100%", fontSize: 16, textAlign: "left" }}>
                                                                {value.itemName !== undefined ? value.itemName : ''}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table style={{ width: "100%", marginTop: "1%", color: 'black' }}>
                                                    <tbody>
                                                        <tr style={{ width: "20%", textAlign: "left" }}>
                                                            <td className="table__orderItems__td1" style={{ fontSize: 16 }}>
                                                                {value.quantity + "   x  " + PriceFormat(value.unitPrice - (value.unitPrice * value.discount / 100))}
                                                            </td>
                                                            {value.discount > 0 &&
                                                                <td style={{ fontSize: 16 }}>
                                                                    <div style={{ color: 'red', display: 'block', marginRight: '50px', textDecoration: 'line-through 3px black' }}>
                                                                        {PriceFormat(value.unitPrice)}
                                                                    </div>
                                                                </td>
                                                            }
                                                            <td className="table__orderItems__td1" style={{ fontSize: 16, textAlign: "right", color: 'black' }}>
                                                                {PriceFormat(value.price)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table >
                                            </div>
                                        );
                                    })
                                    : null}

                                {orderItemsData.length > 0 ?
                                    <div className="single-orderitems-line" style={{ margin: '15px', marginTop: '1px', color: 'black' }}>
                                        <table style={{ width: "100%", marginTop: "5%", color: 'black' }}>
                                            <tbody>
                                                <tr style={{ width: "20%", textAlign: "left" }}>
                                                    <td className="table__orderItems__td1 font-weight-bold" style={{ fontSize: 16, }}>
                                                        Sub Total:
                                                    </td>
                                                    <td className="table__orderItems__td1 font-weight-bold" style={{ fontSize: 16, textAlign: "right", color: 'black' }}>
                                                        {PriceFormat(Number(orderData.subTotal))}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table >
                                    </div>
                                    : null}

                                {orderItemsData.length > 0 && orderData.totalDiscount > 0 ?
                                    <div style={{ margin: '15px', marginTop: '5px', color: 'black' }}>
                                        <table style={{ width: "100%", marginTop: "1%", color: 'black' }}>
                                            <tbody>
                                                <tr style={{ width: "20%", textAlign: "left" }}>
                                                    <td className="table__orderItems__td1 font-weight-bold" style={{ fontSize: 16, }}>
                                                        Order Discount({(orderData.totalDiscount) + "%"}):
                                                    </td>
                                                    <td className="table__orderItems__td1 font-weight-bold" style={{ fontSize: 16, textAlign: "right", color: 'black' }}>
                                                        {PriceFormat(Number(orderData.subTotal * orderData.totalDiscount / 100))}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table >
                                    </div>
                                    : null}

                                {orderItemsData.length > 0 ?
                                    <div style={{ margin: '15px', marginTop: '5px', color: 'black' }}>
                                        <table style={{ width: "100%", marginTop: "1%", color: 'black' }}>
                                            <tbody>
                                                <tr style={{ width: "20%", textAlign: "left" }}>
                                                    <td className="table__orderItems__td1 w-700 font-weight-bold" style={{ fontSize: 16 }}>
                                                        Delivery Charge:
                                                    </td>
                                                    <td className="table__orderItems__td1 font-weight-bold" style={{ fontSize: 16, textAlign: "right", color: 'black' }}>
                                                        {PriceFormat(orderData.deliveryCharges)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table >
                                    </div>
                                    : null}

                                {orderItemsData.length > 0 ?
                                    <div style={{ margin: '15px', marginTop: '5px', color: 'black' }}>
                                        <table style={{ width: "100%", marginTop: "1%", color: 'black' }}>
                                            <tbody>
                                                <tr className="single-orderitems-line" style={{ width: "20%", textAlign: "left", marginTop: '5px' }}>
                                                    <td className="table__orderItems__td1" style={{ fontSize: 20, fontWeight: 'bold' }}>
                                                        TOTAL:
                                                    </td>
                                                    <td className="table__orderItems__td1" style={{ fontSize: 20, textAlign: "right", color: 'black', fontWeight: 'bold' }}>
                                                        {PriceFormat(orderData.totalPrice)}
                                                    </td>
                                                </tr>

                                                <tr className="single-orderitems-line" style={{ width: "20%", textAlign: "left", marginTop: '5px' }}></tr>
                                                <tr className="single-orderitems-line" style={{ width: "20%", textAlign: "left", marginTop: '5px' }}></tr>
                                            </tbody>
                                        </table >
                                    </div>
                                    : null}
                            </section>
                        </main>
                    </div>

                    <div className="footer1">
                        <div style={{ textAlign: 'center' }}>
                            {'Copyright © GUSTA'}
                        </div>
                    </div>

                </ div>

                : <ForbiddenOrderItems orderItems={orderItemsData} />}
        </div>
    );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerInvoice);
